<template>
  <sub-page title="分享APP">
    <div class="share-page">
      <!-- 分享内容卡片 -->
      <div class="share-card">
        <img :src="logo" class="share-logo" alt="logo" />
        <div class="share-info">
          <div class="share-title">江苏智慧人社</div>
          <div class="share-desc">一站式人社服务平台</div>
        </div>
      </div>

      <!-- 分享方式 -->
      <div class="share-panel">
        <div class="panel-title">分享到</div>
        <div class="share-grid">
          <div class="share-item" v-for="(item, idx) in shareList" :key="idx" @click="handleShare(item)">
            <div class="share-icon-wrap" :style="{ background: item.bg }">
              <svg v-if="item.name === 'wechat'" viewBox="0 0 24 24" class="share-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.5 10.5c-.83 0-1.5-.67-1.5-1.5S7.67 7.5 8.5 7.5 10 8.17 10 9s-.67 1.5-1.5 1.5zm7 0c-.83 0-1.5-.67-1.5-1.5S14.67 7.5 15.5 7.5 17 8.17 17 9s-.67 1.5-1.5 1.5zM12 17.5c-2.33 0-4.32-1.45-5.12-3.5h10.24c-.8 2.05-2.79 3.5-5.12 3.5z" fill="#fff"/></svg>
              <svg v-else-if="item.name === 'qq'" viewBox="0 0 24 24" class="share-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-1.5-1.5L11 13H7l3-7 5 5h-4l3 4H10z" fill="#fff"/></svg>
              <svg v-else-if="item.name === 'weibo'" viewBox="0 0 24 24" class="share-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6z" fill="#fff"/></svg>
              <svg v-else viewBox="0 0 24 24" class="share-icon"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="#fff"/></svg>
            </div>
            <span class="share-label">{{ item.label }}</span>
          </div>
        </div>
        <button class="cancel-btn" @click="$router.back()">取消</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'ShareApp',
  components: { SubPage },
  data() {
    return {
      logo: require('@/assets/icons/xh-logo.png'),
      shareList: [
        { name: 'wechat', label: '微信', bg: '#07c160' },
        { name: 'qq', label: 'QQ', bg: '#2E8CF6' },
        { name: 'weibo', label: '微博', bg: '#e6162d' },
        { name: 'more', label: '更多', bg: '#c8c9cc' }
      ]
    }
  },
  methods: {
    handleShare(item) {
      this.$alert('分享到' + item.label)
    }
  }
}
</script>

<style scoped>
.share-page {
  background: #F3F8FB;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.share-card {
  background: #fff;
  margin: calc(40 * var(--w)) calc(24 * var(--w));
  border-radius: calc(16 * var(--w));
  padding: calc(40 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(24 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.share-logo {
  width: calc(112 * var(--w));
  height: calc(112 * var(--w));
  object-fit: contain;
  border-radius: calc(20 * var(--w));
  background: #F3F8FB;
  padding: calc(12 * var(--w));
  flex-shrink: 0;
}
.share-title {
  font-size: calc(36 * var(--w));
  font-weight: 600;
  color: #323233;
  margin-bottom: calc(10 * var(--w));
}
.share-desc {
  font-size: calc(26 * var(--w));
  color: #969799;
}
.share-panel {
  background: #fff;
  border-radius: calc(24 * var(--w)) calc(24 * var(--w)) 0 0;
  padding-bottom: calc(40 * var(--w));
  box-shadow: 0 calc(-4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.panel-title {
  text-align: center;
  padding: calc(32 * var(--w)) 0;
  font-size: calc(28 * var(--w));
  color: #969799;
  border-bottom: 1px solid #f7f8fa;
}
.share-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.share-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(14 * var(--w));
  cursor: pointer;
  transition: transform 0.2s;
}
.share-item:active {
  transform: scale(0.94);
}
.share-icon-wrap {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: calc(28 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 calc(4 * var(--w)) calc(12 * var(--w)) rgba(0, 0, 0, 0.12);
}
.share-icon {
  width: calc(52 * var(--w));
  height: calc(52 * var(--w));
}
.share-label {
  font-size: calc(24 * var(--w));
  color: #323233;
}
.cancel-btn {
  width: calc(100% - 64 * var(--w));
  margin: 0 calc(32 * var(--w));
  height: calc(88 * var(--w));
  background: #F3F4F6;
  color: #323233;
  font-size: calc(30 * var(--w));
  font-weight: 500;
  border: none;
  border-radius: calc(44 * var(--w));
  cursor: pointer;
  transition: all 0.2s;
}
.cancel-btn:active {
  background: #EBEDF0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ShareApp.vue